import { getRouteApi } from '@tanstack/react-router';
import { useUrlSyncedSearch } from '@/hooks/useUrlSyncedSearch';
import type { CatalogueNameSearch } from '../types/product.types';

const ROUTES = {
  bookTypes: getRouteApi('/_auth/product/book-types'),
  bookEditions: getRouteApi('/_auth/product/book-editions'),
} as const;

type CatalogueNameSearchRouteId = keyof typeof ROUTES;

export function useCatalogueNameSearch(routeId: CatalogueNameSearchRouteId) {
  const route = ROUTES[routeId];
  const search: CatalogueNameSearch = route.useSearch();
  const navigate = route.useNavigate();

  const nameSearch = useUrlSyncedSearch({
    appliedText: search.search,
    onApply: (text) => {
      void navigate({
        search: (previous) => ({ ...previous, search: text }),
        replace: true,
      });
    },
  });

  return { ...nameSearch, search };
}
